export default __webpack_public_path__ + "static/media/suez_logo.f1aab4cf.svg";